<template>
    <div class="my">
        <div class="my-container">
            <div class="head">
                <!-- 头像头部 -->
                <div class="card">
                    <l-card type="primary" plaintext l-class="card">
                        <div class="content-item head-container">
                            <img
                                class="avatar"
                                :src="1?'https://wx.qlogo.cn/mmopen/vi_32/xweibozeZ7JEicCpIQlWvSpQ722dbOB8zC8AHCuStTIicq918Rz8BUIh3QNyFiaGJzuOoYLveZp7Wzzj4DEFtTgYSQ/132':'@/assets/images/avatar.png'"
                                alt
                            />

                            <l-badge
                                v-if="is_sales"
                                content="推广代理"
                                class="l-badge-my"
                                @lintap="promotionTap"
                            >
                                <van-icon class-prefix="f-icon" name="tuiguang" />
                            </l-badge>
                        </div>
                    </l-card>
                </div>
            </div>
            <!-- 宫格列表导航 -->
            <l-card type="primary" plaintext full>
                <div class="nav">
                    <div class="nav-item" special="true" catch:tap="toOrderList">
                        <van-icon class-prefix="l-icon" name="order" />
                        <div class="text">我的订单</div>
                    </div>
                    <div
                        v-if="is_agency"
                        class="nav-item"
                        special="true"
                        catch:lintap="toCommissionTap"
                    >
                        <van-icon class-prefix="f-icon" name="tuiguang" />
                        <div class="text">我的提成</div>
                    </div>
                    <div class="nav-item" special="true" catch:tap="toHelp">
                        <van-icon class-prefix="l-icon" name="help" />
                        <div class="text">帮助中心</div>
                    </div>
                    <div class="nav-item" special="true" catch:tap="contactUs">
                        <van-icon class-prefix="l-icon" name="customer-service" />
                        <div class="text">联系客服</div>
                    </div>
                </div>
            </l-card>
            <!-- 消息管理 -->
            <div class="information">
                <v-a id-type="myDelCache" catch:tap="delCache">
                    <van-cell class="my-list" title="清除缓存">
                        <van-icon
                            slot="icon"
                            class="cell-icon"
                            class-prefix="l-icon"
                            name="setting"
                        />
                    </van-cell>
                </v-a>
                <v-a id-type="myContact" catch:tap="contactUs">
                    <van-cell class="my-list" title="售后服务">
                        <van-icon
                            slot="icon"
                            class="cell-icon"
                            class-prefix="l-icon"
                            name="default"
                        />
                    </van-cell>
                </v-a>
                <v-a id-type="myknowTreaty" catch:tap="knowTreaty">
                    <van-cell class="my-list" title="关于公司">
                        <van-icon slot="icon" class="cell-icon" class-prefix="l-icon" name="error" />
                    </van-cell>
                </v-a>
            </div>
        </div>

        <MyTabbar current="user" />
    </div>
</template>
<script>
import { Token } from '../models/token'
import { cache } from '../utils/cache'
import MyTabbar from '../components/my/MyTabbar.vue'
import CardVue from '../components/lin-ui/Card.vue'
import BadgeVue from '../components/lin-ui/Badge.vue'
import AVue from '../components/my/A.vue'

export default {
    name: 'My',
    components: {
        MyTabbar,
        'l-card': CardVue,
        'l-badge': BadgeVue,
        'v-a': AVue
    },
    data() {
        return {
            nickName: '',
            avatarUrl: '',
            is_agency: 0,
            is_sales: 0,
            showPromotion: false,
            truename: null,
            id: 0,
            contactTel: '',
            qrcodeUrl: ''
        }
    },
    computed: {},
    created() {},
    mounted() {
        this.getToken()
    },
    methods: {
        GetRequest() {
            var url = location.search
            if (url.indexOf('?') != -1) {
                var str = url.substr(1),
                    strs = str.split('=')
                return strs[1]
            }
        },
        async getToken() {
            const code = this.GetRequest('code')
            if (code) {
                const token = new Token()
                const res = await token.getTokenFromServer(code, '', 102)
                cache.session('token', res.token)
                cache.set('refresh_token', res.refresh_token)
                // console.log(res);
                this.$router.push({ path: '/' })
            }
        }
    }
}
</script>
<style lang='stylus' scoped>
.card
    position: relative
.avatar
    width: 65px
    border-radius: 50%
.nav
    display: flex
    margin-top: 60px
    .nav-item
        flex: 1
    .text
        font-size: 11px
        font-weight: 400
        color: #666666
        line-height: 15px
        margin-top: 5px
.nav-item
    flex-direction: column !important
    align-items: center
    text-align: center
    cursor: pointer
.information
    margin-top: 10px
.head
    width: 100%
    height: 50px
    background-color: #FA671F
    z-index: 1
.head-container
    display: flex
    align-items: center
    .l-badge-my
        margin-left: 7.5px
.l-badge-my
    right: -24px !important
    // padding: 5rpx 10rpx !important;
    height: 17px !important
    line-height: 17px !important
    // padding: 4rpx 18rpx !important;
.promotion-img-container
    position: absolute
    z-index: 5
    width: 300px
    left: 50%
    top: 50%
    transform: translate3d(-50%, -50%, 0)
.my-list
    border-bottom: 1px solid #f3f3f3
</style>
